import { AccordionView } from "../../common/accordion/accordion.view";
import { useWaterSewageConfig } from "../../common/config/configHooks";
import { IAccordionData } from "../../common/interfaces/accordionData";
import { useAppSelector, useWaterSewageQuery } from "../../Hooks";
import { getOwnerId } from "../../common/utilities/roleHelpers";
import { useMunicipality } from "../../Contexts/MunicipalityKey";
import { BootstrapSpinner } from "../../common/spinners/bootstrapSpinner";
import { ISubscription } from "../../Types/WaterMeterTypes";
import WaterMeterPoint from "./WaterMeterPoint";
import Subscription from "./Subscription";

const WaterMeterPage = () => {
    const waterSewageConfig = useWaterSewageConfig();
    const municipalityConfig = useMunicipality();

    const activeRole = useAppSelector(state => state.role.activeRole);
    const ownerId = getOwnerId(activeRole);

    const {data: waterSewageItems, isLoading: isLoadingWaterSewageItems } = useWaterSewageQuery(municipalityConfig.name, ownerId);

    const createAccordionData = () : IAccordionData[] => {
        let accordionData: { title: string; content: JSX.Element }[] = [];
        
        waterSewageItems?.map(item => {
            const hasSubscriptions = item.subscriptionList && item.subscriptionList.length > 0;
            accordionData.push({
                title: item.matrikkelNr.title ? 
                    item.matrikkelNr.title : 
                    `${item.matrikkelNr.knr}\\${item.matrikkelNr.gnr}\\${item.matrikkelNr.bnr}\\${item.matrikkelNr.fnr ?? 0}\\${item.matrikkelNr.snr ?? 0}`,
                content: (
                    <>
                        {hasSubscriptions ? (
                            <>
                                {item.waterMeterPointDataList && item.waterMeterPointDataList.length > 0 ?
                                    item.waterMeterPointDataList.map((point, index) => (
                                        <WaterMeterPoint key={index} point={point.waterMeterPoint} />
                                    ))
                                    : null}
                                <AccordionView showNarrow={true} isActive={true} content={createSubscriptionAccordionData(item.subscriptionList)} />
                            </>
                        ) : (
                            <p>Ingen vannmålerdata funnet.</p>
                        )}
                    </>
                )
            });
        });

        return accordionData;
    }

    const createSubscriptionAccordionData = (subscriptions: ISubscription[])  => {
        let accordionData: { title: string; content: JSX.Element }[] = [];

        accordionData.push({
            title: "Gebyr",
            content: (<Subscription subscriptions={subscriptions} ></Subscription>)
        });

        return accordionData;
    }

    if (isLoadingWaterSewageItems)
        return <BootstrapSpinner title="Henter vannmålerdataene dine" />;
    else {
        return (
        <div className="container my-water-meters">
            <h1>Vann og avløp</h1>
            {waterSewageConfig?.hideService ? (
                "Tjenesten er dessverre ikke tilgjengelig."
            ) : (
                <>
                {waterSewageConfig?.alertText &&
                    waterSewageConfig?.alertText !== "" && (
                    <div className="infoBoxLanding">
                        <p>{waterSewageConfig?.alertText}</p>
                    </div>
                    )
                }
                 {!waterSewageItems || waterSewageItems.length > 0 ? (
                    <>
                        <p>{waterSewageConfig?.ingressText}</p>
                        <p><strong>Merk:</strong> Vannmåleren til eiendommer med felles vannmåler vises ikke her, kun vannmåleren til egen eiendom.</p>
                        <AccordionView
                            content={createAccordionData()}
                            hideBorder={true}
                        />
                    </>
                    ) : (
                    <p>{waterSewageConfig?.notFoundText}</p>
                    )
                }
                </>
            )}
        </div>
        );
    }
}

export default WaterMeterPage;